export default "__VITE_ASSET__DOh5Pyqg__"